// extracted by mini-css-extract-plugin
export default {"main__orders":"orders_main__orders__OzaAK","order__list":"orders_order__list__5ncf-"};